export const environment = {
  production: false,
  currentApiHostname: 'mdp.api.centrc.dev',
  pusher_secret: 'a6991c780bbca2d50015',
  pusher_cluster: 'mt1',
};
